import { render, staticRenderFns } from "./configtablelist.vue?vue&type=template&id=ab27423c&scoped=true&"
import script from "./configtablelist.vue?vue&type=script&lang=js&"
export * from "./configtablelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab27423c",
  null
  
)

export default component.exports